module.exports = __webpack_public_path__ + "img/05.c57ac356.jpg";